import { render, staticRenderFns } from "./ProfileViewStudentPermissionsCard.vue?vue&type=template&id=727280b6&"
import script from "./ProfileViewStudentPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./ProfileViewStudentPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports